<template>
  <div v-if="label !== 'cold'" class="whyCard surface-card" :class="label">
    <div class="whyTop">
      <span class="tempPill" :class="label">{{ label === 'hot' ? '🔥 Hot' : 'Warm' }}</span>
      <span class="whyLabel">Why now</span>
    </div>
    <h2 class="whyHeadline">{{ whyNow || 'Worth a touch — in an active play.' }}</h2>
  </div>
</template>

<script setup lang="ts">
// The panel's opening line — why this person, right now. A real signal earns the
// hero; cold renders nothing, because "no signal" is what the rail already said
// by filing them under cold.
defineProps<{
  label: 'hot' | 'warm' | 'cold'
  whyNow: string | null
}>()
</script>

<style scoped>
/* The hero is deliberately heavier than the standard surface card. */
.whyCard { position: relative; padding: var(--space-5) var(--space-6); box-shadow: var(--shadow-md); }
.whyCard::before { content: ''; position: absolute; left: 0; top: var(--space-4); bottom: var(--space-4); width: 4px; border-radius: 999px; background: var(--color-accent); }
.whyCard.hot::before { background: var(--color-reply); }
.whyTop { display: flex; align-items: center; justify-content: space-between; margin-bottom: var(--space-3); }
.tempPill { font-size: 11px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; padding: 3px 10px; border-radius: 999px; background: var(--color-bg-subtle); color: var(--color-text-secondary); }
.tempPill.hot { background: var(--color-reply-soft); color: var(--color-reply); }
.whyLabel { font-size: var(--fs-xs); font-weight: var(--fw-semibold); letter-spacing: var(--tracking-wide); text-transform: uppercase; color: var(--color-text-tertiary); }
.whyHeadline { font-family: var(--font-display); font-size: var(--fs-xl); font-weight: var(--fw-semibold); letter-spacing: var(--tracking-tight); line-height: var(--lh-tight); }
</style>
